import {
  TableCell,
  TableRow,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import React, { useState } from 'react';

import { MdDelete, MdEdit, MdRemoveRedEye } from 'react-icons/md';
import { IoMdEyeOff } from 'react-icons/io';
import theme from '../../../styles/theme';
import { ButtonActions, HoverActions } from './styles';

const TableCadastroWebHookEventHeaderBodyRow = ({
  setIsEditarModal,
  setOpenModalCadastrarHeader,
  setOpenModalDeletarHeader,
  header,
}) => {
  const [mostrarValor, setMostarValor] = useState(false);

  return (
    <>
      <TableRow key={header.id}>
        <TableCell width={120}>{header.name}</TableCell>
        <TableCell width={250}>
          {mostrarValor ? header.value : '*******'}
        </TableCell>
        <TableCell width={120}>
          {header.createdAt
            ? format(new Date(header.createdAt), 'dd/MM/yyyy HH:mm', {
                timeZone: 'America/Sao_Paulo',
              })
            : '-'}
        </TableCell>
        <TableCell width={120}>{header.createdUser}</TableCell>
        <TableCell width={150}>
          <WrapperFlex gap={10} alignCenter>
            <HoverActions>
              <Tooltip
                background={theme.greenDefault}
                color={theme.bgWhite}
                position="left"
                text={`${mostrarValor ? 'Esconder Valor' : 'Mostrar Valor'}`}
              >
                <ButtonActions
                  width={40}
                  padding={5}
                  justifyCenter
                  onClick={() => {
                    setMostarValor(!mostrarValor);
                  }}
                  background={theme.greenDefault}
                >
                  {mostrarValor ? (
                    <IoMdEyeOff color={theme.white} size={25} />
                  ) : (
                    <MdRemoveRedEye color={theme.white} size={25} />
                  )}
                </ButtonActions>
              </Tooltip>
            </HoverActions>
            <HoverActions>
              <Tooltip
                background={theme.blue}
                color={theme.bgWhite}
                position="left"
                text="Editar Evento"
              >
                <ButtonActions
                  width={40}
                  padding={5}
                  justifyCenter
                  onClick={() => {
                    setIsEditarModal(header);
                    setOpenModalCadastrarHeader(true);
                  }}
                  background={theme.blue}
                >
                  <MdEdit color={theme.white} size={25} />
                </ButtonActions>
              </Tooltip>
            </HoverActions>
            <HoverActions>
              <Tooltip
                background={theme.red}
                color={theme.bgWhite}
                position="left"
                text="Excluir"
              >
                <ButtonActions
                  width={40}
                  padding={5}
                  justifyCenter
                  onClick={() =>
                    setOpenModalDeletarHeader({
                      isOpen: true,
                      eventId: header.id,
                    })
                  }
                  background={theme.red}
                >
                  <MdDelete color={theme.white} size={25} />
                </ButtonActions>
              </Tooltip>
            </HoverActions>
          </WrapperFlex>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableCadastroWebHookEventHeaderBodyRow;
